"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getQuickFactEstimatedAPR", {
  enumerable: true,
  get: function get() {
    return _personalLoans.getDriverEstimatedApr;
  }
});
Object.defineProperty(exports, "getQuickFactLoanAmount", {
  enumerable: true,
  get: function get() {
    return _personalLoans.getDriverLoanAmount;
  }
});
Object.defineProperty(exports, "getQuickFactLoanTerm", {
  enumerable: true,
  get: function get() {
    return _personalLoans.getDriverLoanTerm;
  }
});
Object.defineProperty(exports, "getQuickFactMinCreditScore", {
  enumerable: true,
  get: function get() {
    return _personalLoans.getDriverMinCreditScore;
  }
});
var _personalLoans = require("@nerdwallet/marketplace/drivers/personal-loans");